var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.925L11.75 15.675L13.15 14.275L16 17.125L21.65 11.475L23.05 12.875L16 19.925ZM21.5 10H19.5V5H17.5V8H7.5V5H5.5V19H11.5V21H5.5C4.95 21 4.47933 20.8043 4.088 20.413C3.69667 20.0217 3.50067 19.5507 3.5 19V5C3.5 4.45 3.696 3.97933 4.088 3.588C4.48 3.19667 4.95067 3.00067 5.5 3H9.675C9.85833 2.41667 10.2167 1.93767 10.75 1.563C11.2833 1.18833 11.8667 1.00067 12.5 1C13.1667 1 13.7627 1.18767 14.288 1.563C14.8133 1.93833 15.1673 2.41733 15.35 3H19.5C20.05 3 20.521 3.196 20.913 3.588C21.305 3.98 21.5007 4.45067 21.5 5V10ZM12.5 5C12.7833 5 13.021 4.904 13.213 4.712C13.405 4.52 13.5007 4.28267 13.5 4C13.5 3.71667 13.404 3.47933 13.212 3.288C13.02 3.09667 12.7827 3.00067 12.5 3C12.2167 3 11.9793 3.096 11.788 3.288C11.5967 3.48 11.5007 3.71733 11.5 4C11.5 4.28333 11.596 4.521 11.788 4.713C11.98 4.905 12.2173 5.00067 12.5 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory2);
export default __webpack_public_path__ + "static/media/inventory2.9293b055cf3ac2bf522890ee5c685663.svg";
export { ForwardRef as ReactComponent };